import { Hero } from "./components/Hero"
import { SolutionSection, PartnerSection, FoerderungSection, ContactSection } from "./components/Collections"

const Start = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-white to-gray-50 text-gray-900">
      <Hero />
      <SolutionSection />
      <PartnerSection />
      <FoerderungSection />
      <ContactSection />
    </div>
  )
}

export default Start
